export enum ConfigurationType {
  MinimumWages = 0,
  Violation = 1,
  BusinessTrip = 2,
  BusinessTripRates = 3,
  Timesheet = 4,
  TimesheetAdditional = 5,
  Basic = 6,
  AlertReminders = 7,
  Printout = 8,
  Gps = 9,
  Integration = 10,
  Scanner = 11,
  Country = 12,
  Payroll = 13,
}
